import { EServiceType } from '../../../../../../../../redux/reducers';
import { EServiceTypes } from '../../../../../../../../types/microfrontends/buyPackage';

export const mapServiceType = (serviceType: EServiceType): EServiceTypes => {
  switch (serviceType) {
    case EServiceType.auction:
      return EServiceTypes.Auction;
    case EServiceType.calltracking:
      return EServiceTypes.Calltracking;
    case EServiceType.free:
      return EServiceTypes.FreeObject;
    case EServiceType.paid:
      return EServiceTypes.DebitObject;
    case EServiceType.premium:
      return EServiceTypes.PremiumObject;
    case EServiceType.top3:
      return EServiceTypes.Top3;
  }
};
